import React from "react";

import SheriSections from "./Component/S_Sections/Team";
import Team from "./Component/Team/Team";

import Program from "./Component/Program/Program";
import RoadMap from "./Component/RoadMap/RoadMap";

import dwarve from "../../assets/images/dwarve1.png";
import Rarity from "./Component/Rarity/Rarity";
import Homecover from "./Component/S_Sections/Homecover/Homecover";
import Story from "./Component/Story-section/Story";
import Beterayal from "./Component/Beterayal/Beterayal";
import "./Home.scss";

const Home = () => {
  return (
    <>
      <div className="home_container">
        {/* <div className='homeimg'>
                    <img src={dwarve} alt="" />
                </div> */}
        <Homecover />
        <Story />
        <SheriSections />
        <Program />
        <RoadMap />
        <Team />
        <Rarity />
        <Beterayal />
      </div>
    </>
  );
};

export default Home;
